import api from "./api";

const sources = {
  getSources() {
    return api.get(`/sources/`);
  },
  addSources(args) {
    return api.post(`/sources/`, args);
  },
  editSources(args, id) {
    return api.patch(`/sources/${id}`, args);
  },
  deleteSources(id) {
    return api.delete(`/sources/${id}`);
  },
};

export default sources;
